import { forwardRef } from 'react';
import { Typography } from '../../Typography/Typography.js';
import { ButtonSize, ButtonVariant } from '../../../utils/buttonStyles.js';
import { FileUploaderValues } from './FileUploaderValues.js';
import { getFieldsetResetStyles, getFileUploaderLabelStyles, getFileUploaderHandlerWrapperStyles, getFileUploaderHandlerStyles, getFileUploaderValuesStyles } from './FileUploaderStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { FieldMessage } from '../Field/FieldMessage/FieldMessage.js';
import { FileInput } from '../FileInput/FileInput.js';

const FileUploader = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    label,
    message,
    value,
    disabled = false,
    isLoading = false,
    children,
    onChange,
    'data-id': dataId,
    name,
    multiple = true,
    ...props
  } = _ref;
  const {
    handleChange,
    handleDelete
  } = useFileUploaderHandlers({
    value,
    onChange
  });
  return jsxs("fieldset", {
    css: getFieldsetResetStyles,
    ref: ref,
    "data-id": dataId,
    ...props,
    children: [label && jsx(Typography, {
      css: getFileUploaderLabelStyles,
      component: "legend",
      variant: "small",
      children: label
    }), message && jsx(FieldMessage, {
      type: message.type,
      children: message.content
    }), jsxs("div", {
      css: getFileUploaderHandlerWrapperStyles,
      children: [jsx(FileInput, {
        "data-id": dataId ? `${dataId}-input` : undefined,
        css: getFileUploaderHandlerStyles,
        isLoading: isLoading,
        disabled: disabled,
        size: ButtonSize.SMALL,
        variant: ButtonVariant.OUTLINED,
        onChange: handleChange,
        name: name,
        multiple: multiple,
        children: children
      }), jsx(FileUploaderValues, {
        css: getFileUploaderValuesStyles,
        values: value,
        onDelete: handleDelete
      })]
    })]
  });
});
function useFileUploaderHandlers(_ref2) {
  let {
    value: currentFiles,
    onChange
  } = _ref2;
  const handleChange = e => {
    if (!e.target.files) {
      return;
    }
    const files = Array.from(e.target.files);
    const newFiles = files.filter(newFile => !currentFiles.some(isSameFile(newFile)));
    onChange([...currentFiles, ...newFiles]);
  };
  const handleDelete = fileToFilter => {
    onChange(currentFiles.filter(file => fileToFilter !== file));
  };
  return {
    handleChange,
    handleDelete
  };
}
function isSameFile(fileA) {
  return fileB => fileA.name === fileB.name && fileA.size === fileB.size && fileA.type === fileB.type;
}
FileUploader.displayName = 'FileUploader';

export { FileUploader };
//# sourceMappingURL=FileUploader.js.map
